<template>
  <div
    v-drag-card
    v-if="visible"
    :class="[
      'ai-tools-container',
      { expanded: isExpanded, collapsed: isExpanded && showHistory },
    ]"
  >
    <!-- 历史记录列表 -->
    <history-list
      v-if="isExpanded && showHistory"
      ref="historyList"
      :historyId="historyId"
      @newChat="handleEdit"
      @select="selectHistory"
      @delete="deleteHistory"
    />
    <!-- 主卡片 -->
    <div
      v-if="pages == 'main'"
      :class="['ai-tools-card', { 'ai-tools-card__white': false }]"
    >
      <!-- logo -->
      <div
        v-show="showDefault || isFadingIn"
        :class="[
          'ai-tools-logo-bg',
          { 'ai-tools-logo-bg__fade': isFadingOut },
          { 'ai-tools-logo-bg__enter': isFadingIn },
        ]"
      ></div>
      <img
        v-show="showDefault || isFadingIn"
        :class="[
          'ai-tools-logo',
          { 'ai-tools-logo__fade': isFadingOut },
          { 'ai-tools-logo__enter': isFadingIn },
        ]"
        :src="cdnUrl + 'ai-logo.svg'"
        alt=""
      />
      <!-- 头部 -->
      <div class="ai-tools-wrap">
        <div
          :class="[
            'ai-tools-header',
            'ai-tools-header__dragging',
            {
              'ai-tools-header__expanded':
                isExpanded || (!isExpanded && messageLists.length && !isWrite),
            },
          ]"
        >
          <img
            v-if="isExpanded"
            class="action-btn"
            @click="showHistoryList"
            :src="cdnUrl + 'ai-collaspe.svg'"
            alt=""
          />
          <img
            v-if="!isExpanded && messageLists.length && !isWrite"
            class="ai-avatar"
            :src="cdnUrl + 'ai-assets-icon.svg'"
            alt="AI助手"
          />
          <div class="ai-tools-actions-right">
            <!-- <template v-if="!isExpanded">
            <el-tooltip content="新建对话" placement="top">
              <img
                class="action-btn"
                @click="handleEdit"
                :src="cdnUrl + 'ai-add.svg'"
                alt=""
              />
            </el-tooltip>
            <el-tooltip content="历史对话" placement="top">
              <img
                class="action-btn"
                @click="handleRecord"
                :src="cdnUrl + 'ai-record.svg'"
                alt=""
              />
            </el-tooltip>
          </template>
          <el-tooltip v-if="isExpanded" content="收起" placement="top">
            <img
              class="action-btn"
              @click="toggleExpand()"
              :src="cdnUrl + 'ai-sx.svg'"
              alt=""
            />
          </el-tooltip>

          <el-tooltip v-else content="展开" placement="top">
            <img
              class="action-btn"
              @click="toggleExpand()"
              :src="cdnUrl + 'ai-full.svg'"
              alt=""
            />
          </el-tooltip> -->

            <img
              class="action-btn"
              @click="handleClose"
              :src="cdnUrl + 'ai-closed.svg'"
              alt=""
            />
          </div>
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="ai-tools-body">
        <!-- 主内容区 -->
        <div
          class="chat_window global-ai-content"
          ref="chat_window"
          @scroll="handleScroll"
          v-if="messageLists.length && !isWrite"
        >
          <div class="chat-body">
            <div
              class="item"
              :class="item.messageType == 'answer' ? 'left' : 'right'"
              v-for="(item, index) in messageLists"
              :key="index"
            >
              <div
                class="message"
                :class="item.messageType == 'answer' ? 'AI' : 'monkey'"
              >
                <loading v-if="item.status == 'loading'"></loading>
                <span v-if="item.messageType == 'question'">{{
                  item.content
                }}</span>
                <!-- 数值表格 -->
                <template v-else-if="item.messageType == 'answer'">
                  <thank-box
                    v-if="item.thought && item.scenarioType != 3"
                    :loading="item.thankLoading"
                    :key="item.id"
                  >
                    <div v-html="compileMarkdown(item.thought)"></div>
                  </thank-box>
                  <thank-box
                    v-if="
                      item.thoughtArr &&
                      item.thoughtArr.length &&
                      item.scenarioType == 4
                    "
                    :loading="item.thankLoading"
                    :key="item.id"
                    :isAi="true"
                    :thoughtArr="item.thoughtArr"
                  >
                  </thank-box>
                  <template
                    v-if="
                      item.content &&
                      ![3].includes(item.scenarioType) &&
                      item.style != 'card'
                    "
                  >
                    <div
                      v-for="(block, idx) in renderedBlocks(item.content)"
                      :key="idx"
                    >
                      <!-- 普通 markdown 文本 -->
                      <div
                        v-if="block.type === 'markdown'"
                        class="md-content"
                        v-html="block.html"
                      ></div>
                      <!-- 表格块：按钮 + 表格 -->
                      <div
                        v-else-if="block.type === 'table'"
                        class="table-block"
                      >
                        <md-table :html="block.html">
                          <div v-html="block.html"></div>
                        </md-table>
                      </div>
                    </div>
                  </template>
                  <bi-table
                    v-if="item.scenarioType == 3 && item.content"
                    :data="JSON.parse(item.content)"
                  ></bi-table>
                  <ai-card
                    v-if="
                      item.scenarioType == 4 &&
                      item.style == 'card' &&
                      item.content
                    "
                    :cardInfo="JSON.parse(item.content)"
                    @cardClick="cardClick"
                  ></ai-card>
                </template>
                <handle
                  v-if="
                    item.messageType == 'answer' &&
                    item.status == 'completed' &&
                    (item.id || item.hasReChoose)
                  "
                  :item="item"
                  :copyText="item.content"
                  :isCreating="isMessage"
                  :isLike="item.likeStatus"
                  :isUnlike="item.dislikeStatus"
                  :hideCopy="item.style == 'card'"
                  :hasReChoose="item.hasReChoose"
                  @regenerate="handleRegenerate(item)"
                  @reChoose="reChoose"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-show="showDefault || isFadingOut || (isFadingIn && !isExpanded)"
          :class="[
            'ai-tools-content',
            { 'ai-tools-content__fade': isFadingOut },
            { 'ai-tools-content__enter': isFadingIn && !isExpanded },
          ]"
        >
          <!-- 欢迎区域 -->
          <div class="welcome-section">
            <div class="welcome-text">
              <h3>{{ getWelcomeText }}</h3>
              <p>{{ getWelcomeDesc }}</p>
            </div>
          </div>

          <!-- 猜你想问 -->
          <div class="suggestions-section">
            <div class="text-img" v-if="isWrite">
              <div class="text-img__item" @click="showSmsText">
                <img :src="cdnUrl + 'ai-dxwa.svg'" alt="" />
                <div class="text-overlay">
                  <h3 class="text-title">短信文案</h3>
                  <p class="text-desc">快速生成精准的营销短信</p>
                </div>
              </div>
              <div class="text-img__item" @click="showFreeWrite">
                <img :src="cdnUrl + 'ai-zycz.svg'" alt="" />
                <div class="text-overlay">
                  <h3 class="text-title">自由创作</h3>
                  <p class="text-desc">随心创作，适配多元场景</p>
                </div>
              </div>
            </div>
            <template v-else>
              <img
                class="suggestions-title"
                :src="cdnUrl + 'ai-ask.svg'"
                alt=""
              />
              <div class="suggestions-list" @scroll="handleSuggestionsScroll">
                <button
                  v-for="suggestion in suggestions"
                  :key="suggestion.id"
                  class="suggestion-btn"
                  @click="handleSuggestionClick(suggestion)"
                >
                  <div class="suggestion-btn-wrap">
                    <span>{{ suggestion.recommendQuestion }}</span>
                  </div>
                  <span class="arrow">›</span>
                </button>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- 功能标签 -->
      <!-- <div class="feature-tags-section">
        <div class="feature-tags">
          <button
            v-for="(tag, index) in featureTags"
            :key="index"
            class="feature-tag"
            :class="{ active: selectedTag === tag.type }"
            @click="selectFeature(tag)"
          >
            <img
              class="tag-icon"
              :src="cdnUrl + tag.active"
              alt=""
              v-if="selectedTag === tag.type"
            />
            <img class="tag-icon" :src="cdnUrl + tag.icon" alt="" v-else />
            <span>{{ tag.name }}</span>
          </button>
        </div>
      </div> -->

      <!-- 底部输入框 -->
      <!-- <div class="ai-tools-footer">
        <div
          :class="[
            'input-wrapper',
            { 'input-wrapper__hover': hasInput },
            { 'input-wrapper__disabled': isWrite },
          ]"
        >
          <el-input
            ref="inputRef"
            type="textarea"
            class="ai-textarea"
            :autosize="{ minRows: 1, maxRows: 5 }"
            placeholder="输入你想问我的问题..."
            v-model="inputText"
            :maxlength="2000"
            :disabled="isWrite"
            @keydown.enter.native.prevent="handleSubmit"
          />
          <div class="btn-wrapper">
            <img
              class="submit-btn submit-btn_disabled"
              v-if="!hasInput || isMessage"
              :src="cdnUrl + 'ai-send-disabled.svg'"
              alt=""
            />
            <img
              @click="handleSubmit"
              class="submit-btn"
              v-else
              :src="cdnUrl + 'ai-send.svg'"
              alt=""
            />
          </div>
        </div>
      </div> -->
    </div>
    <!-- 历史对话子组件 -->
    <history
      v-else-if="pages == 'history'"
      @close="handleClose"
      @back="pages = 'main'"
      @edit="handleEdit"
      @toggleExpand="toggleExpand"
      @delete="deleteHistory"
    ></history>
    <!-- 短信文案子组件 -->
    <messageText
      :type="type"
      v-else-if="pages == 'smsText'"
      :isExpanded="isExpanded"
      @close="handleClose"
      @back="pages = 'main'"
      @edit="handleEdit"
      @record="handleRecord"
      @toggleExpand="toggleExpand"
      @showHistoryList="showHistoryList"
      @add="addFn"
    >
    </messageText>
    <!-- 自由创作子组件 -->
    <freeWrite
      v-else-if="pages == 'freeWrite'"
      :isExpanded="isExpanded"
      @close="handleClose"
      @back="pages = 'main'"
      @edit="handleEdit"
      @record="handleRecord"
      @toggleExpand="toggleExpand"
      @showHistoryList="showHistoryList"
    >
    </freeWrite>
    <!-- BI表格选择组件 -->
    <select-bi-table
      v-if="showSelect"
      v-model="showSelect"
      :msgId="msgId"
      :conversationId="conversation.id"
      :hasReChoose="hasReChoose"
      @confirm="handleConfirm"
      @close="handleBiTableClose"
    />
    <!-- 表格选择组件 -->
    <select-activity-table
      v-if="showSmsSelect"
      v-model="showSmsSelect"
      :type="selectType"
      :msgId="msgId"
      :conversationId="conversation.id"
      :hasReChoose="hasReChoose"
      @confirm="handleSmsConfirm"
      @close="handleSmsTableClose"
    ></select-activity-table>
    <!-- 报告 -->
    <aiReportDialog
      v-if="showReport"
      :cardInfo="cardInfo"
      :visible.sync="showReport"
      platformCode="BI"
    />
  </div>
</template>

<script>
import { marked } from "marked";
import { mapGetters } from "vuex";
import historyList from "./components/historyList.vue";
import History from "./components/history.vue";
import messageText from "./components/messageText.vue";
import freeWrite from "./components/freeWrite.vue";
import handle from "@/components/ai/components/handle.vue";
import loading from "@/components/ai/components/loading.vue";
import biTable from "@/components/ai/components/biTable.vue";
import thankBox from "@/components/ai/components/thankBox.vue";
import mdTable from "@/components/ai/components/mdTable.vue";
import aiCard from "@/components/ai/components/aiCard.vue";
import SelectBiTable from "@/components/ai/components/selectBiTable.vue";
import SelectActivityTable from "@/components/ai/components/selectActivityTable.vue";
import aiReportDialog from "@/components/ai/components/aiReportDialog.vue";
import {
  getRecommended,
  recognizeIntent,
  createConversation,
  getConversationPage,
  queryData,
  getMessagesPage,
  getSellerBICategory,
} from "@/api/ai/newAi.js";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import dayjs from "dayjs";
export default {
  name: "AiTools",
  directives: {
    dragCard: {
      bind(el, binding, vnode) {
        const getScale = () => {
          return 1;
        };

        const bindDragEvents = (dragHeaderEl) => {
          if (dragHeaderEl._dragBound) return;
          dragHeaderEl._dragBound = true;

          dragHeaderEl.onmousedown = (e) => {
            e.preventDefault();
            e.stopPropagation();

            const disabled = binding.value && binding.value.disabled;
            if (disabled) return;

            const dragDom = el;
            const scale = getScale();

            // getBoundingClientRect 返回视口坐标（已缩放），除以 scale 得到 DOM 坐标
            const rect = dragDom.getBoundingClientRect();
            const dragDomWidth = rect.width / scale;
            const dragDomHeight = rect.height / scale;

            // #app 实际 DOM 尺寸 = 视口尺寸 / scale
            const totalWidth = window.innerWidth / scale;
            const totalHeight = window.innerHeight / scale;

            const minLeft = 0;
            const maxLeft = totalWidth - dragDomWidth;
            const minTop = 0;
            const maxTop = totalHeight - dragDomHeight;

            // 初始位置由 rect 反算
            const startLeft = rect.left / scale;
            const startTop = rect.top / scale;

            const startX = e.clientX;
            const startY = e.clientY;

            // 禁用过渡，避免拖拽滞后
            const prevTransition = dragDom.style.transition;
            dragDom.style.transition = "none";

            document.onmousemove = function (e) {
              e.preventDefault();
              e.stopPropagation();

              // 视口位移除以 scale 得到 DOM 位移
              const deltaX = (e.clientX - startX) / scale;
              const deltaY = (e.clientY - startY) / scale;
              let left = startLeft + deltaX;
              let top = startTop + deltaY;

              if (maxLeft >= minLeft) {
                left = Math.max(minLeft, Math.min(maxLeft, left));
              }
              if (maxTop >= minTop) {
                top = Math.max(minTop, Math.min(maxTop, top));
              }

              dragDom.style.left = left + "px";
              dragDom.style.top = top + "px";
              dragDom.style.right = "auto";
              dragDom.style.bottom = "auto";
            };

            document.onmouseup = function (e) {
              e.preventDefault();
              e.stopPropagation();
              document.onmousemove = null;
              document.onmouseup = null;
              dragDom.style.transition = prevTransition;
            };
          };
        };

        const setupDrag = () => {
          const dragHeaderEl = el.querySelector(".ai-tools-header");
          if (dragHeaderEl) {
            bindDragEvents(dragHeaderEl);
          }
        };

        setupDrag();

        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.addedNodes.length > 0) {
              const dragHeaderEl = el.querySelector(".ai-tools-header");
              if (dragHeaderEl && !dragHeaderEl._dragBound) {
                bindDragEvents(dragHeaderEl);
              }
            }
          });
        });

        observer.observe(el, {
          childList: true,
          subtree: true,
        });

        el._dragObserver = observer;
        el._dragSetup = setupDrag;
      },
      update(el, binding) {
        if (el._dragSetup) {
          el._dragSetup();
        }
      },
      unbind(el) {
        if (el._dragObserver) {
          el._dragObserver.disconnect();
          el._dragObserver = null;
        }
        const dragHeaderEl = el.querySelector(".ai-tools-header");
        if (dragHeaderEl) {
          dragHeaderEl._dragBound = false;
          dragHeaderEl.onmousedown = null;
        }
        el._dragSetup = null;
      },
    },
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    // 1 短信文案
    type: {
      type: Number,
      default: 0,
    },
    // AI分析其他入口
    openType: {
      type: Number,
      default: null,
    },
    sellerId: {
      type: String,
      default: "",
    },
  },
  components: {
    historyList,
    History,
    messageText,
    freeWrite,
    handle,
    loading,
    biTable,
    thankBox,
    mdTable,
    aiCard,
    SelectBiTable,
    SelectActivityTable,
    aiReportDialog,
  },
  data() {
    return {
      uid: Math.random().toString(36).substring(2, 9),
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
      visible: this.value,
      pages: "main",
      isExpanded: false,
      isFadingOut: false,
      isFadingIn: false,
      inputText: "",
      selectedTag: this.openType,
      suggestions: [],
      currentPage: 1,
      pageSize: 20,
      isLoading: false,
      hasMore: true,
      featureTags: [
        {
          type: 1,
          name: "智能助手",
          icon: "ai-znzs.svg",
          active: "ai-znzs-active.svg",
          isRequest: true,
        },
        // { name: "店铺诊断", icon: "ai-dpzd.svg", active: "ai-dpzd-active.svg" },
        {
          type: 2,
          name: "营销策略",
          icon: "ai-yxcl.svg",
          active: "ai-yxcl-active.svg",
          isRequest: true,
        },
        {
          type: 3,
          name: "AgentBI",
          icon: "ai-fx.svg",
          active: "ai-fx-active.svg",
          isRequest: true,
        },
        {
          type: 4,
          name: "AI分析",
          icon: "ai-fx.svg",
          active: "ai-fx-active.svg",
          isRequest: true,
        },
        {
          type: 5,
          name: "文案生成",
          icon: "ai-wasc.svg",
          active: "ai-wasc-active.svg",
          isRequest: false,
        },
      ],
      showHistory: true,
      historyId: null,
      controller: null,
      isMessage: false,
      messagenew: "",
      thought: "",
      thoughtArr: [],
      cardStyle: "",
      dataLists: [],
      messageLists: [],
      conversation: {},
      reqId: "",
      autoScrollEnabled: true,
      sellerBICategory: "",
      messagePage: 1,
      messagePageSize: 20,
      messageHasMore: true,
      messageLoading: false,
      isFirstMessage: true,
      isChangeHistory: false,
      showSelect: false,
      showSmsSelect: false,
      selectType: "",
      showReport: false,
      cardInfo: {},
      msgId: "",
      hasReChoose: false,
    };
  },
  computed: {
    ...mapGetters(["softwareInfo"]),
    renderedBlocks() {
      return (text) => {
        return this.$parseMarkdownToBlocks(text);
      };
    },
    // 生成文案场景特殊处理，输入框不可用，且不展示历史记录和推荐问题
    isWrite() {
      return this.selectedTag == 5;
    },
    // 判断是否有输入内容
    hasInput() {
      return this.inputText && this.inputText.trim().length > 0;
    },
    getWelcomeText() {
      let welcomeText = "Hi，我是你专属的AI助手";
      if (this.selectedTag == 1) {
        welcomeText = "软件任何使用问题都可以问我哦";
      } else if (this.selectedTag == 2) {
        welcomeText = "让我来给你推荐运营策略";
      } else if (this.selectedTag == 3) {
        welcomeText = "让我来给你生成数据报表";
      } else if (this.selectedTag == 4) {
        welcomeText = "让我来给你分析复盘";
      } else if (this.isWrite) {
        welcomeText = "让我来给你生成文案";
      }
      return welcomeText;
    },
    getWelcomeDesc() {
      let welcomeDesc = "今天我能帮你什么呢？";
      if (this.selectedTag == 1) {
        welcomeDesc = "功能查询、软件使用问题、短信营销规则、活动设置等";
      } else if (this.selectedTag == 2) {
        welcomeDesc = "个性化推荐日常、大促不同行业、不同营销场景的运营策略";
      } else if (this.selectedTag == 3) {
        welcomeDesc = "客户、会员、商品等维度的个性化报表生成";
      } else if (this.selectedTag == 4) {
        welcomeDesc = "分析GMV、日报/周报/月报、大促复盘等数据";
      } else if (this.isWrite) {
        welcomeDesc = "生成营销短信文案、个性化文案";
      }
      return welcomeDesc;
    },
    showDefault() {
      return false;
      return (
        !this.messageLists.length || (this.messageLists.length && this.isWrite)
      );
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.visible = newVal;
      },
      immediate: true,
    },
    messageLists(val) {
      if (val && val.length) {
        this.$nextTick(() => {
          if (this.$refs.chat_window) {
            const links = this.$refs.chat_window.querySelectorAll("a");
            links.forEach((link) => {
              link.setAttribute("target", "_blank");
              // 建议同时添加 rel 属性以增强安全性
              link.setAttribute("rel", "noopener noreferrer");
            });
          }
        });
      }
    },
    type: {
      handler(newVal) {
        if (newVal) {
          this.showSmsText();
        }
      },
      immediate: true,
    },
  },
  created() {
    if (!this.openType) {
      this.getRecommendedQuestions();
      this.getList();
      // 获取卖家淘宝分类
      getSellerBICategory().then((res) => {
        if (res.code == 200) {
          this.sellerBICategory = res.data.category;
        }
      });
    }
  },
  methods: {
    addFn(text) {
      this.$emit("add", text);
    },
    compileMarkdown(text) {
      return marked(text); // 直接使用
    },
    showHistoryList() {
      this.showHistory = !this.showHistory;
    },
    toggleExpand(historyId = "", type = "") {
      this.isExpanded = !this.isExpanded;
      if (type == "history") {
        this.pages = "main";
        this.selectedTag = "";
        if (historyId) {
          this.historyId = historyId;
        }
      } else {
        this.historyId = null;
      }
    },
    handleEdit() {
      this.selectedTag = "";
      this.pages = "main";

      // 触发进场动画
      this.triggerFadeIn();

      this.messageLists = [];
      this.getRecommendedQuestions();
      this.newChatFn();
    },
    deleteHistory(id) {
      if (this.conversation.id == id) {
        this.getList();
      }
    },
    // 触发进场动画
    triggerFadeIn() {
      // 延迟显示IP元素并触发进场动画
      setTimeout(() => {
        this.isFadingIn = true;
      }, 50);

      // 动画完成后重置状态
      setTimeout(() => {
        this.isFadingIn = false;
      }, 450);
    },
    handleRecord() {
      this.pages = "history";
    },
    handleClose() {
      this.$emit("input", false);
    },
    selectFeature(tag) {
      this.selectedTag = this.selectedTag === tag.type ? "" : tag.type;
      this.historyId = null;
      if (!this.selectedTag || (tag.isRequest && !this.messageLists.length)) {
        this.getRecommendedQuestions();
      }
    },
    handleSuggestionClick(suggestion) {
      this.selectedTag = suggestion.type;
      // 触发退场动画
      this.triggerFadeOut();
      this.getReportMessage(suggestion.recommendQuestion, suggestion.type);
    },
    handleSubmit() {
      if (this.isMessage) return;
      if (this.inputText) {
        // 触发退场动画
        this.triggerFadeOut();
        if (this.selectedTag) {
          this.getReportMessage(this.inputText);
        } else {
          recognizeIntent({
            message: this.inputText,
          }).then((res) => {
            this.selectedTag = res.data.scenarioType;
            this.getReportMessage(this.inputText, res.data.scenarioType);
          });
        }
      }
    },
    // 触发退场动画
    triggerFadeOut() {
      this.isFadingOut = true;

      // 动画完成后更新状态
      setTimeout(() => {
        this.isFadingOut = false;
      }, 400);
    },
    showSmsText() {
      this.pages = "smsText";
    },
    showFreeWrite() {
      this.pages = "freeWrite";
    },
    getRecommendedQuestions(isLoadMore = false) {
      if (this.isLoading) return;

      const page = isLoadMore ? this.currentPage + 1 : 1;
      const query = {
        userId: "BI_" + this.softwareInfo.userId,
        current: page,
        size: this.pageSize,
        type: this.selectedTag,
      };

      this.isLoading = true;
      getRecommended(query)
        .then((res) => {
          if (isLoadMore) {
            this.suggestions = [...this.suggestions, ...res.data.records];
          } else {
            this.suggestions = res.data.records;
            this.currentPage = 1;
          }

          // 判断是否还有更多数据
          this.hasMore = res.data.records.length >= this.pageSize;
          this.currentPage = page;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    // 滚动到底部加载更多
    handleSuggestionsScroll(e) {
      const target = e.target;
      if (
        target.scrollTop + target.clientHeight >= target.scrollHeight - 10 &&
        this.hasMore &&
        !this.isLoading
      ) {
        this.getRecommendedQuestions(true);
      }
    },
    getList() {
      getConversationPage({
        platform: "BI",
        userId: this.softwareInfo.userId,
      }).then((res) => {
        if (res.data.records && res.data.records.length) {
          this.conversation = res.data.records[0];
          this.setDetail(this.conversation.id);
        } else {
          this.messageLists = [];
          this.selectedTag = "";
          this.getRecommendedQuestions();
          this.newChatFn();
        }
      });
    },
    selectHistory(id) {
      this.messagePage = 1;
      this.messageHasMore = true;
      this.isFirstMessage = true;
      this.selectedTag = "";
      this.pages = "main";
      this.setDetail(id);
      this.conversation = {
        id,
      };
      if (this.historyId) {
        this.historyId = null;
      }
    },
    setDetail(id, isLoadMore = false) {
      const page = isLoadMore ? this.messagePage + 1 : 1;
      getMessagesPage({
        conversationId: id,
        current: page,
        size: this.messagePageSize,
      }).then((res) => {
        if (isLoadMore) {
          this.messageLists = [
            ...res.data.records.reverse(),
            ...this.messageLists,
          ];
        } else {
          this.messageLists = res.data.records.reverse();
        }

        this.messageHasMore = res.data.records.length >= this.messagePageSize;
        this.messagePage = page;
        this.messageLoading = false;

        if (res.data.records && res.data.records.length) {
          this.selectedTag =
            res.data.records[res.data.records.length - 1].scenarioType;
        }
        if (this.isFirstMessage) {
          this.scrollWindow();
          this.isFirstMessage = false;
        }
      });
    },
    // 新建对话
    newChatFn() {
      const query = {
        platform: "BI",
        userId: this.softwareInfo.userId,
      };
      createConversation(query).then((res) => {
        if (res.code == 200) {
          this.conversation = res.data;
          this.isChangeHistory = false;
        }
      });
    },
    appendMessage(options) {
      const {
        messageType,
        content,
        status = "completed",
        thought,
        dislikeStatus,
        likeStatus,
        id,
        scenarioType,
        thankLoading,
        thoughtArr,
        style,
        hasReChoose,
      } = options;
      const message = {
        messageType,
        status: status,
        content,
        thought,
        dislikeStatus,
        likeStatus,
        id,
        scenarioType,
        thankLoading,
        thoughtArr,
        style,
        hasReChoose,
      };
      let len = this.messageLists.length;
      if (
        len &&
        ["loading", "add"].includes(this.messageLists[len - 1].status)
      ) {
        this.messageLists[len - 1] = message;
        this.$set(this.messageLists, len - 1, message);
      } else {
        this.messageLists.push(message);
      }
    },
    // 滚动AI聊天窗口
    scrollWindow() {
      this.$nextTick(() => {
        const objDiv = this.$refs.chat_window;
        if (!objDiv) return;

        const doScroll = () => {
          objDiv.scrollTop = objDiv.scrollHeight;
        };

        // 立即尝试一次滚动
        doScroll();

        // 查找所有图片并监听加载事件
        const images = objDiv.querySelectorAll("img");
        if (images.length === 0) return;

        let loadedCount = 0;
        const totalImages = images.length;

        const checkAllLoaded = () => {
          loadedCount++;
          if (loadedCount >= totalImages) {
            this.$nextTick(() => {
              doScroll();
            });
          }
        };

        images.forEach((img) => {
          if (img.complete) {
            // 图片已加载完成
            checkAllLoaded();
          } else {
            // 监听图片加载
            img.addEventListener("load", checkAllLoaded);
            img.addEventListener("error", checkAllLoaded); // 加载失败也触发
          }
        });
      });
    },
    // 处理用户滚动事件
    handleScroll() {
      const { scrollTop, clientHeight, scrollHeight } = this.$refs.chat_window;
      this.autoScrollEnabled = scrollTop + clientHeight >= scrollHeight;

      // 滚动到顶部加载更多历史消息
      if (scrollTop <= 10 && this.messageHasMore && !this.messageLoading) {
        this.messageLoading = true;
        this.setDetail(this.conversation.id, true);
      }
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },
    // 获取数据报表
    getReportMessage(message, scenarioType, dataList) {
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
      this.appendMessage({
        messageType: "question",
        content: message,
        status: "completed",
      });
      this.appendMessage({
        messageType: "answer",
        scenarioType: scenarioType ? scenarioType : this.selectedTag,
        thought: "",
        content: "",
        thankLoading: false,
        status: "loading",
      });
      this.isMessage = true;
      this.controller = new AbortController();
      const obj = {
        platform: "BI",
        scenarioType: scenarioType ? scenarioType : this.selectedTag,
        userId: this.softwareInfo.userId,
        sellerId: this.sellerId || "",
        conversationId: this.conversation.id,
        message: message,
        reqId: this.conversation.id,
        companyId: this.softwareInfo.platformCompanyInfoId || "",
      };
      if (obj.scenarioType == 1 || obj.scenarioType == 2) {
        obj.category = this.sellerBICategory;
      }
      let _this = this;
      let fn = "/yunqi-ai-api/ai/dataReport/report";
      if (obj.scenarioType == 2) {
        fn = "/yunqi-ai-api/marketing-strategy/stream";
      } else if (obj.scenarioType == 1) {
        fn = "/yunqi-ai-api/ai/sendMessage";
      } else if (obj.scenarioType == 4) {
        fn = "/yunqi-ai-api/ai-analysis/stream";
      }
      if (dataList) {
        fn = "/yunqi-ai-api/ai-analysis/report/stream";
        if (this.selectType == "sence") {
          obj.scenarioSubType = 2;
          obj.biReportCodeList = dataList;
        } else if (this.selectType == "message") {
          obj.scenarioSubType = 3;
          obj.smsBatchList = dataList;
        } else if (this.selectType == "hd") {
          obj.scenarioSubType = 4;
          obj.activityList = dataList;
        }
      }
      this.messagenew = "";
      this.thought = "";
      this.thoughtArr = [];
      this.cardStyle = "";
      this.inputText = "";
      this.reqId = "";
      this.msgId = "";
      this.$nextTick(() => {
        this.scrollWindow();
      });
      fetchEventSource(fn, {
        signal: this.controller.signal,
        openWhenHidden: true,
        method: "POST",
        headers: {
          Accept: "text/event-stream",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(obj),
        onopen(response) {
          if (response.ok) {
            console.log("SSE连接成功", response);
          } else {
            throw new Error(`SSE连接失败: `, response);
          }
        },
        onmessage(event) {
          //服务返回的数据
          console.log("res数据", event);
          let id = "";
          let thankLoading = true;
          let content = null;
          if (event.event == "thought") {
            try {
              let newdata = JSON.parse(event.data);
              _this.thought = _this.thought + newdata.msg;
            } catch (err) {}
          } else if (event.event == "message") {
            try {
              let newdata = JSON.parse(event.data);
              if (!_this.reqId) {
                _this.messagenew = _this.messagenew + newdata.msg;
              }
            } catch (err) {
              _this.messagenew = event.data;
            }
            if (_this.messagenew) {
              thankLoading = false;
            }
          } else if (event.event == "reqId") {
            _this.reqId = event.data;
          } else if (event.event == "done") {
            try {
              const newdata = JSON.parse(event.data);
              id = newdata.id;
            } catch (err) {}
          } else if (event.event == "task") {
            try {
              let newdata = JSON.parse(event.data);
              // 如果是 completed 状态，查找并替换对应的 running 状态的 task
              if (
                newdata.status === "completed" ||
                newdata.status === "failed"
              ) {
                // 提取 task 的标识信息（从 msg 中提取报表名称）
                // 例如：从 "开始提取「全店销售分析」报表数据..." 中提取 "全店销售分析"
                const matchRunning = newdata.msg.match(/「([^」]+)」/);
                if (matchRunning) {
                  const taskName = matchRunning[1];
                  // 查找数组中是否有包含相同名称的 running 状态的 task
                  const index = _this.thoughtArr.findIndex((item) => {
                    if (item.status !== "running") return false;
                    const itemMatch = item.msg.match(/「([^」]+)」/);
                    return itemMatch && itemMatch[1] === taskName;
                  });
                  if (index !== -1) {
                    // 找到匹配项，替换它
                    _this.$set(_this.thoughtArr, index, newdata);
                  } else {
                    // 没找到匹配项，直接添加
                    _this.thoughtArr.push(newdata);
                  }
                } else {
                  // 无法提取名称，直接添加
                  _this.thoughtArr.push(newdata);
                }
              } else {
                // 不是 completed 状态，直接添加
                _this.thoughtArr.push(newdata);
              }
            } catch (err) {}
          } else if (event.event == "card") {
            thankLoading = false;
            try {
              _this.messagenew = event.data;
              _this.cardStyle = "card";
            } catch (err) {}
          } else if (event.event == "select-items-bi") {
            thankLoading = false;
            try {
              const newdata = JSON.parse(event.data);
              _this.showSelect = true;
              _this.selectType = "sence";
              _this.msgId = newdata.msg;
            } catch (err) {}
          } else if (event.event == "select-items-sms") {
            thankLoading = false;
            try {
              const newdata = JSON.parse(event.data);
              _this.showSmsSelect = true;
              _this.selectType = "message";
              _this.msgId = newdata.msg;
            } catch (err) {}
          } else if (event.event == "select-items-activity") {
            thankLoading = false;
            try {
              const newdata = JSON.parse(event.data);
              _this.showSmsSelect = true;
              _this.selectType = "hd";
              _this.msgId = newdata.msg;
            } catch (err) {}
          }
          let status =
            !_this.thought && !_this.messagenew && !_this.thoughtArr.length
              ? "loading"
              : "add";
          if (id) {
            status = "completed";
            thankLoading = false;
          }
          const scenarioTypeCopy = scenarioType
            ? scenarioType
            : _this.selectedTag;
          if (!_this.reqId && scenarioTypeCopy == 3) {
            status = "loading";
          }
          if (!_this.isChangeHistory) {
            _this.changeHistoryList();
            _this.isChangeHistory = true;
          }
          if ([1, 2, 4].includes(scenarioTypeCopy)) {
            content = _this.messagenew;
          }
          if (!_this.msgId) {
            _this.appendMessage({
              messageType: "answer",
              scenarioType: scenarioTypeCopy,
              thought: _this.thought,
              thoughtArr: _this.thoughtArr,
              content: content ? content : "",
              thankLoading,
              status: status,
              dislikeStatus: false,
              likeStatus: false,
              id: id,
              style: _this.cardStyle,
            });
          } else {
            let len = _this.messageLists.length;
            if (len) {
              let lastMessage = _this.messageLists[len - 1];
              if (lastMessage.status == "loading") {
                _this.messageLists.splice(len - 1, 1);
              }
            }
          }
          if (_this.autoScrollEnabled) {
            _this.$nextTick(() => {
              _this.scrollWindow();
            });
          }
        },
        onerror(err) {
          // 服务异常
          console.error("SSE错误:", err);
          _this.appendMessage({
            messageType: "answer",
            content: "当前请求较多，请稍后再试~",
            status: "completed",
          });
          _this.question = "";
          _this.isMessage = false;
          throw event;
        },
        onclose() {
          setTimeout(() => {
            _this.scrollWindow();
          }, 500);
          const scenarioTypeCopy = scenarioType
            ? scenarioType
            : _this.selectedTag;
          if (scenarioTypeCopy == 3) {
            _this.getReportData();
          } else {
            _this.isMessage = false;
          }
        },
      });
    },
    getReportData() {
      queryData({
        platform: "BI",
        reqId: this.reqId,
        userId: this.softwareInfo.userId,
        companyId: this.softwareInfo.platformCompanyInfoId || "",
        sellerId: this.sellerId || "",
        conversationId: this.conversation.id,
        scenarioType: 3,
      })
        .then((res) => {
          if (res.code == 200) {
            this.isMessage = false;
            // 更新messageLists最后一条数据，添加biData字段
            if (this.messageLists.length > 0) {
              const lastIndex = this.messageLists.length - 1;
              this.$set(
                this.messageLists[lastIndex],
                "content",
                JSON.stringify(res.data)
              );
              this.$set(
                this.messageLists[lastIndex],
                "id",
                JSON.stringify(res.data.id)
              );
              this.$set(this.messageLists[lastIndex], "status", "completed");
            }
          }
        })
        .catch(() => {
          this.isMessage = false;
        });
    },
    // 重新生成
    handleRegenerate(val) {
      const index = this.messageLists.findIndex((item) => item.id == val.id);
      const preIndex = index - 1;
      const preObj = this.messageLists[preIndex];
      if (preObj && preObj.messageType == "question") {
        this.selectedTag = val.scenarioType;
        this.getReportMessage(preObj.content, val.scenarioType);
      }
    },
    changeHistoryList() {
      if (this.$refs.historyList) {
        const selectedId = this.$refs.historyList.selectedId;
        if (selectedId != this.conversation.id) {
          this.historyId = null;
          this.$refs.historyList && this.$refs.historyList.getList();
        }
      }
    },
    handleConfirm(values) {
      this.selectType = "sence";
      let str = this.openType ? "帮我分析：" : "已选择报表：";
      const valueArr = [];
      const enumNames = [];
      values.forEach((item) => {
        let valueStr = `【${item.name}】报表`;
        if (item.payTimeRangeList && item.payTimeRangeList.length > 0 && ["TOP10_PRODUCT_SALES_TAG"].includes(item.enumName)) {
          valueStr += `、时间为${item.payTimeRangeList.map((item) => dayjs(item.intervalStartTime).format("YYYY-MM-DD") + "至" + dayjs(item.intervalEndTime).format("YYYY-MM-DD")).join("、")}`;
        } else if (item.payTimeStart && item.payTimeEnd) {
          valueStr += `、时间为${item.payTimeStart}至${item.payTimeEnd}`;
        }
        if (
          item.payTimeEnd &&
          ["MEMBER_LIFE_CYCLE", "CUSTOMER_LIFE_CYCLE"].includes(item.enumName)
        ) {
          valueStr += `、时间截止${item.payTimeEnd}`;
        }
        valueArr.push(valueStr);
        enumNames.push(item.enumName);
      });
      str = str + valueArr.join("、");
      this.getReportMessage(str, 4, enumNames);
    },
    handleSmsConfirm(values, type) {
      console.log("选中的报表：", values);
      let str = "";
      const selectType = type ? type : this.selectType;
      this.selectType = selectType;
      const valueArr = [];
      if (selectType == "hd") {
        str = this.openType ? "帮我分析：" : "已选互动活动：";
        values.forEach((item) => {
          valueArr.push(`【${item.activityName}/${item.activityId}】`);
        });
      } else {
        str = this.openType ? "帮我分析：" : "已选短信活动：";
        values.forEach((item) => {
          valueArr.push(`【${item.title}/${item.batchId}】`);
        });
      }
      str = str + valueArr.join("、");
      this.getReportMessage(str, 4, values);
    },
    handleBiTableClose() {
      this.hasReChoose = false;
      this.showSelect = false;
      this.appendMessage({
        messageType: "answer",
        content:
          "好的，你还可以试试：帮我做一下上个月的复盘、帮我帮我生成短信营销效果复盘、帮我分析上个月的满额有礼活动数据",
        thankLoading: false,
        status: "completed",
        hasReChoose: true,
      });
    },
    handleSmsTableClose() {
      this.hasReChoose = false;
      this.showSmsSelect = false;
      if (this.selectType == "hd") {
        this.appendMessage({
          messageType: "answer",
          content:
            "好的，你还可以试试：帮我做一下上个月的复盘、帮我分析一下商品复购数据、帮我帮我生成短信营销效果复盘",
          thankLoading: false,
          status: "completed",
          hasReChoose: true,
        });
      } else {
        this.appendMessage({
          messageType: "answer",
          content:
            "好的，你还可以试试：帮我做一下上个月的复盘、帮我分析一下商品复购数据、帮我分析上个月的满额有礼活动数据",
          thankLoading: false,
          status: "completed",
          hasReChoose: true,
        });
      }
    },
    async openByBtn(sendData, type) {
      // const { data } = await getSellerBICategory();
      // this.sellerBICategory = data.category;
      getConversationPage({
        platform: "BI",
        userId: this.softwareInfo.userId,
      }).then(async (res) => {
        if (res.data.records && res.data.records.length) {
          this.conversation = res.data.records[0];
          const page = 1;
          getMessagesPage({
            conversationId: this.conversation.id,
            current: page,
            size: this.messagePageSize,
          }).then((res) => {
            this.messageLists = res.data.records.reverse();

            this.messageHasMore =
              res.data.records.length >= this.messagePageSize;
            this.messagePage = page;
            this.messageLoading = false;

            if (res.data.records && res.data.records.length) {
              this.selectedTag =
                res.data.records[res.data.records.length - 1].scenarioType;
            }
            if (this.isFirstMessage) {
              this.scrollWindow();
              this.isFirstMessage = false;
            }
            if (type == "sence") {
              this.handleConfirm(sendData);
            } else {
              this.handleSmsConfirm(sendData, type);
            }
          });
        } else {
          const query = {
            platform: "BI",
            userId: this.softwareInfo.userId,
          };
          const { data: conversation } = await createConversation(query);
          this.conversation = conversation;
          this.isChangeHistory = false;
          if (type == "sence") {
            this.handleConfirm(sendData);
          } else {
            this.handleSmsConfirm(sendData, type);
          }
        }
      });
    },
    cardClick(cardInfo) {
      this.cardInfo = cardInfo;
      this.showReport = true;
    },
    // 重新选择
    reChoose() {
      if (this.selectType == "sence") {
        this.showSelect = true;
      } else if (this.selectType == "message") {
        this.showSmsSelect = true;
      } else if (this.selectType == "hd") {
        this.showSmsSelect = true;
      }
      this.hasReChoose = true;
    },
  },
};
</script>

<style lang="scss">
.global-ai-content {
  color: #333;
  .img_code img {
    width: 150px !important;
    display: block;
  }

  .markdown_class {
    img {
      max-width: 400px;
      display: block;
      margin-top: 20px;
    }
  }

  hr {
    border-top: 1px solid #f2f2f3;
    border-bottom: 0px;
    border-right: 0px;
    border-left: 0px;
  }

  ul,
  ol {
    margin-top: 10px !important;
    margin-bottom: 0 !important;
    font-size: 14px;

    img {
      max-width: 400px;
      display: block;
      margin-top: 20px;
    }
  }

  &.ai-report-text {
    ul,
    ol {
      margin-left: -20px;
    }
  }

  li {
    margin-bottom: 12px !important;
    margin-left: 20px !important;
  }

  p {
    white-space: break-spaces;
    line-height: 25px;
    margin-top: 0;
    font-weight: 400 !important;
    font-size: 14px;

    img {
      max-width: 400px;
      margin-top: 10px;
    }
  }

  a {
    color: #3159ff !important;
    margin-top: 5px;
  }

  th,
  td {
    padding: 10px 16px;
    font-weight: 400;
    text-align: left;
  }

  tbody tr {
    border-top: 1px solid #e5e9f2;
    td {
      max-width: 330px;
      min-width: 130px;
    }
  }

  th:not(:last-child) {
    border-right: 1px solid #e5e9f2;
  }
  td:not(:last-child) {
    border-right: 1px solid #e5e9f2;
  }

  table {
    width: max-content;
    border-collapse: collapse;
    border: 1px solid #e5e9f2;
    border-top: none;
    display: block;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .language-json {
    white-space: pre-wrap;
  }
  h1 {
    font-size: 20px;
    font-weight: bold;
    margin: 20px 0px;
  }
  h2 {
    font-size: 18px;
    font-weight: bold;
    margin: 20px 0px;
  }
  h3 {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0px;
  }
  h4 {
    font-size: 14px;
    font-weight: bold;
    margin: 20px 0px;
  }
}
.global-ai-content.fullscreen {
  table {
    border-top: 1px solid #e5e9f2;
    border-radius: 8px;
  }
}
</style>

<style lang="scss" scoped>
.ai-tools-container {
  position: fixed;
  bottom: 0;
  right: 20px;
  z-index: 9999;
  transition: all 0.3s ease;
  width: 670px;
  height: calc(100% - 70px);
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.25);
  border-radius: 16px;
  top: 60px;
  user-select: text;
}

.ai-tools-card {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #f7f5ff 0%, #ffffff 100%);
  border-radius: 16px;
  box-shadow: 0px 4px 20px rgba(102, 126, 234, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.3s ease;
  position: relative;
  &__white {
    background: #ffffff;
  }
}

.ai-tools-logo-bg {
  width: 236px;
  height: 293px;
  background: #e5edff;
  border-radius: 0px 0px 0px 0px;
  filter: blur(200px);
  position: absolute;
  left: 0px;
  top: 0px;
  opacity: 1;
  transform: translateY(0);
  transition: all 400ms cubic-bezier(0.4, 0, 0.2, 1);
}

.ai-tools-logo-bg__fade {
  opacity: 0;
  transform: translateY(-30px);
}

.ai-tools-logo-bg__enter {
  animation: fadeInUp 400ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.ai-tools-logo {
  position: absolute;
  left: 25px;
  top: -22px;
  width: 220px;
  height: 263px;
  opacity: 1;
  transform: translateY(0);
  transition: all 400ms cubic-bezier(0.4, 0, 0.2, 1);
}

.ai-tools-logo__fade {
  opacity: 0;
  transform: translateY(-30px);
}

.ai-tools-logo__enter {
  animation: fadeInUp 400ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.ai-tools-container.expanded {
  width: calc(100% - 40px);
  display: flex;

  .ai-tools-content {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0px);
    width: 800px;
  }

  .ai-tools-logo {
    left: 30%;
    top: -22px;
  }

  .welcome-section {
    margin-left: 260px;
  }

  .chat-body {
    width: 800px;
    margin: 0 auto;
  }

  .feature-tags-section {
    width: 800px;
    margin: 0 auto;
  }

  .ai-tools-footer {
    width: 800px;
    margin: 0 auto;
  }
}

.ai-tools-container.collapsed {
  .ai-tools-card {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    box-shadow: none;
  }
}

.ai-tools-wrap {
  padding: 6px 20px 20px 12px;
}

.ai-tools-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: transparent;
  height: 50px;
  &__dragging {
    cursor: move;
  }
  &__expanded {
    justify-content: space-between;
  }
}

.ai-tools-actions-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btn {
  cursor: pointer;
  width: 32px;
  height: 32px;
  z-index: 1;
}

.ai-tools-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: transparent;
  padding-bottom: 8px;
}

.ai-tools-sidebar {
  width: 200px;
  background-color: #fff;
  border-right: 1px solid #ebe7ff;
  overflow-y: auto;
  padding: 12px;
}

.history-item {
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #606266;
  margin-bottom: 6px;
  transition: all 0.2s;
}

.history-item:hover {
  background-color: #f5f7fa;
}

.history-item.active {
  background-color: #ebe7ff;
  color: #667eea;
}

.ai-tools-content {
  flex: 1;
  overflow-y: auto;
  padding: 0 20px 20px;
  opacity: 1;
  transform: translateY(0);
  transition: all 400ms cubic-bezier(0.4, 0, 0.2, 1);
}

.ai-tools-content__fade {
  opacity: 0;
  transform: translateY(-30px);
}

.ai-tools-content__enter {
  animation: fadeInUp 400ms cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

.welcome-section {
  display: flex;
  align-items: center;
  padding: 0px 10px 14px;
  background: transparent;
  margin-left: 200px;
}

.welcome-icon {
  width: 120px;
  height: 120px;
  flex-shrink: 0;
  margin-right: 16px;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><circle cx="60" cy="60" r="60" fill="%23f0edff"/></svg>');
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.welcome-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.welcome-text h3 {
  margin: 0 0 14px 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.welcome-text p {
  margin: 0;
  font-size: 14px;
  color: #888;
}

.suggestions-section {
  background: linear-gradient(180deg, #e7e9fe 0%, #ffffff 100%);
  border-radius: 20px 20px 20px 20px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  padding: 16px 20px 20px 20px;
  margin-top: 32px;
  opacity: 0.96;
}

.suggestions-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 8px;
}

.ai-badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
}

.suggestions-title h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.suggestions-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
  padding-right: 4px;

  &::-webkit-scrollbar {
    display: none;
  }
}

.suggestion-btn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 25px 8px 16px;
  background-color: #fff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: all 0.2s;
  text-align: left;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.03);

  &-wrap {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &:hover {
    background-color: #fafaff;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.1);

    .suggestion-btn-wrap {
      white-space: wrap;
    }
  }
}

.arrow {
  color: #bbb;
  font-size: 20px;
  font-weight: 300;
  line-height: 1;
}

.feature-tags-section {
  padding: 0px 20px;
  background: #fff;
}

.feature-tags {
  display: flex;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}

.feature-tag {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 7px 14px;
  background-color: #fff;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  transition: all 0.2s;
  white-space: nowrap;

  &:hover {
    background: #f4f4f4;
  }
}

.feature-tag.active {
  background: linear-gradient(330deg, #2986fe 0%, #d7abff 100%);
  color: #fff;
}

.ai-tools-footer {
  padding: 12px 20px 20px 20px;
  background-color: #fff;
}

.input-wrapper {
  position: relative;
  border-radius: 8px;
  border: 1px solid #f1f1f1;
  padding: 12px;

  &__hover {
    border: 1px solid #3159ff;
  }

  &__disabled {
    cursor: not-allowed;
    background-color: #f5f7fa;
  }
}

.ai-textarea {
  width: 100%;
  font-size: 14px;
  padding-right: 12px;
}

.ai-textarea ::v-deep textarea {
  padding: 0px;
  resize: none;
  outline: none;
  &::placeholder {
    color: #bfbfbf;
    font-weight: 400;
  }

  &::-webkit-scrollbar {
    width: 4px;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d9d9d9;
  }

  &::-webkit-scrollbar-track {
    background-color: #f3f3f3;
  }
}

.ai-textarea ::v-deep .el-textarea__inner {
  border-color: #e4e7ed;
  border-radius: 8px !important;
  padding-right: 12px;
  border: none !important;
  color: #333;
}

.btn-wrapper {
  display: flex;
  justify-content: flex-end;
}

.submit-btn {
  width: 32px;
  height: 32px;
  cursor: pointer;

  &._disabled {
    cursor: not-allowed;
  }
}

.submit-btn:hover:not(:disabled) {
  transform: scale(1.05);
}

.submit-btn:disabled {
  background: #c0c4cc;
  cursor: not-allowed;
}

.submit-btn ::v-deep .el-icon-arrow-up {
  font-size: 14px;
}

.text-img {
  display: flex;
  gap: 20px;
}

.text-img__item {
  position: relative;
  flex: 1;
  cursor: pointer;
}

.text-img__item img {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  left: 0;
  top: 22px;
  padding: 20px;
}

.text-title {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 8px 0;
}

.text-desc {
  font-size: 14px;
  color: #666666;
  margin: 0;
}

.ai-avatar {
  height: 50px;
}

.chat_window {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 0px 20px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  .item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    &:last-child {
      margin-bottom: 20px;
    }

    img {
      width: 40px;
      height: 40px;
    }

    .message {
      position: relative;
      max-width: 450px;
      line-height: 20px;
      font-size: 14px;
      word-break: break-all;

      span {
        white-space: pre-wrap;
      }
    }

    .AI {
      color: #333333;
      padding: 0px;
      max-width: 100%;
      width: 100%;
    }

    .monkey {
      background: #ddeaff;
      border-radius: 16px;
      color: #333;
      padding: 12px 16px;
    }
  }

  .left {
    justify-content: start;
    padding-bottom: 50px;
    margin-bottom: 0px;

    &:hover {
      .message_handle {
        display: flex;
      }
    }
  }

  .right {
    justify-content: end;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
